exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.feed .feedItem[data-v-0e08dee0] {\n  height: auto !important;\n}\n.search[data-v-0e08dee0] {\n  padding: 0.5rem 0.75rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 0.8rem;\n  border: 1px solid #e6eaee;\n  background: #f5f8fa;\n}\n.search > input[data-v-0e08dee0] {\n    border: 0;\n    background-color: transparent;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0e08dee0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/FeedcardMissedcheckins.vue
// module id = 2443
// module chunks = 0